// extracted by mini-css-extract-plugin
export var divider = "_gz-7";
export var itemsToggle = "_gz-8";
export var mergeModal = "_gz-1";
export var optionCard = "_gz-4";
export var radioGroup = "_gz-6";
export var radioOption = "_gz-0";
export var selected = "_gz-5";
export var shipmentOptions = "_gz-2";
export var tableOptions = "_gz-3";